<template>
  <v-hover v-slot="data">
    <v-card
      :disabled="storeIsDisabled(item)"
      :to="to"
      color="brand-beige-light"
      flat
    >
      <template v-if="!hoverImgSwap && item.Image">
        <v-img
          :class="{'hover-zoom': hover && hoverZoom, 'hover-zoom-active': hover && hoverZoom && data.hover}"
          :height="dense ? 130 : 300"
          :src="item.Image"
          :style="{filter: (storeIsDisabled(item) ? 'grayscale(1)' : 'grayscale(0)')}"
        />
      </template>

      <template v-else-if="hoverImgSwap && item.Image && item?.Category?.Image">
        <div :style="{'min-height': dense ? '130px' : '300px', 'background': '#c0cab8'}">
          <v-img
            :height="dense ? 130 : 300"
            :src="item.Category.Image"
            :style="{height: hover && hoverZoom && data.hover ? 0 : dense ? '130px' : '300px', filter: (storeIsDisabled(item) ? 'grayscale(1)' : 'grayscale(0)')}"
          />

          <v-img
            :class="{'hover-zoom': hover && hoverZoom, 'hover-zoom-active': hover && hoverZoom && data.hover, 'hover-fade': hover, 'hover-fade-active': hover && data.hover}"
            :height="dense ? 130 : 300"
            :src="item.Image"
            :style="{height: hover && hoverZoom && data.hover ? dense ? '130px' : '300px' : 0 , filter: (storeIsDisabled(item) ? 'grayscale(1)' : 'grayscale(0)')}"
          />
        </div>
      </template>

      <v-avatar
        :size="dense ? 50 : 80"
        class="ml-2 mt-2"
        color="brand-green-dark"
        style="position: absolute; top:0; left:0; border: var(--v-brand-green-dark-base) solid 1px;"
      >
        <img :src="item.Logo">
      </v-avatar>

      <v-container fluid>
        <v-row class="align-center flex-nowrap">
          <v-col
            class="pr-0"
            style="max-width: calc(100% - 80px)"
          >
            <div
              v-if="item.Name"
              class="brand-text-heading brand-green-dark--text"
            >
              <div
                class="overflow-hidden text-no-wrap"
                style="text-overflow: ellipsis;"
              >
                {{ toLocaleUpperCase(item.Category.Name) }}
              </div>
            </div>

            <div
              v-if="item.Category.Description && descUseColumn"
              class="pt-2 brand-grey--text"
            >
              <div
                class="overflow-hidden text-no-wrap"
                style="text-overflow: ellipsis;"
              >
                {{ item.Category.Description }}
              </div>
            </div>
          </v-col>

          <v-col class="text-right pa-2 pa-md-3">
            <v-chip
              v-if="storeIsOpened(item)"
              class="brand-green-dark--text px-1 px-md-2"
              color="brand-beige"
              dark
              label
              small
            >
              <v-icon
                class="mr-1"
                small
              >
                mdi-clock
              </v-icon>
              <span class="brand-text-title">{{ storeDefaultTime(item, 'XS') }}</span>
            </v-chip>

            <v-chip
              v-else
              class="brand-text-title brand-green-dark--text px-1 px-md-2"
              color="brand-beige"
              dark
              label
              small
            >
              <span class="brand-text-title">{{ $t('Store.Status.Closed').toLocaleUpperCase($i18n.locale) }}</span>
            </v-chip>
          </v-col>
        </v-row>

        <v-row
          v-if="!descUseColumn"
          no-gutters
        >
          <v-col style="max-width: calc(100%)">
            <div
              class="brand-grey--text"
              style="min-height: 24px;"
            >
              <div
                class="overflow-hidden text-no-wrap"
                style="text-overflow: ellipsis;"
              >
                {{ item.Category.Description }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-hover>
</template>

<script>
import StoreCardMixin from '@/theme/default/views/home/StoreCard.js'

export default {
  name  : 'StoreCard',
  mixins: [StoreCardMixin],
  props : {
    hoverZoom: {
      type   : Boolean,
      default: false
    },

    hoverImgSwap: {
      type   : Boolean,
      default: false
    },

    descUseColumn: {
      type   : Boolean,
      default: false
    }
  }
}
</script>

<style scoped src="@/theme/default/views/home/StoreCard.css"></style>
<style scoped>
/deep/ .hover-zoom .v-image__image {
  transform: scale(1);
  transition: all 0.3s;
}

/deep/ .hover-fade .v-image__image {
  opacity: 0;
  transition: all 0.3s;
}

/deep/ .hover-fade-active .v-image__image {
  opacity: 1;
}
</style>
